import api from "../../api";
import {ProductType, UserId} from "platformed-client/types";
import {param, typedQuery} from "../typing";

export const user = typedQuery(["user", param<UserId>("userId")], async userId => {
  return await api.users.get(userId);
});

// `product` scopes the list to users who can access that product. Pass "All"
// (the ProductContext default outside a product) to list every user.
export const accountUsers = typedQuery(["accountUsers", param<ProductType>("product")], async product => {
  return await api.users.listAccountUsers(product);
});

export const userTeams = typedQuery(["userTeams", param<UserId>("userId")], async userId => {
  return await api.users.getTeams(userId);
});

export const serviceUserApikeys = typedQuery(["serviceUserApikeys", param<UserId>("userId")], async userId => {
  return await api.users.listServiceApikeys(userId);
});
